//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Report.js";
import "../no/Object.js";
import "../Report/Report.ReportManager.js";
let d=[[],[[["pCommands","libraryFile"],"ExportCommandsToLibraryFile",{},2,0],[["commandLibrariesCount","pCommandLibraries"],"GetCommandLibraries",{},0,0],[["commandLibrary","command"],"CreateCommandBuilder",{R_:{builder:"Report.CommandBuilder"}},2,0],[["pCommandLibrary","libraryFile"],"NewCommandImporter",{R_:{pCommandImporter:"Report.CommandImporter"}},2,0],[["journalIdentifier"],"Find",{R_:{foundObject:"TaggedObject"}},1,0]],[]];
SPLM.Report.CommandManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Report.CommandManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;